<script setup lang="ts">
import { useMmText } from '../base/text'
import MmBadge from '../base/MmBadge.vue'
defineProps<{ labels: string[] }>()
const { t } = useMmText()
</script>

<template><span v-if="labels.length" class="source-tags"><MmBadge v-for="label in labels" :key="label" status="neutral" class="source-tag">{{ t(label) }}</MmBadge></span></template>

<style scoped>
.source-tags { display: inline-flex; gap: var(--s-1); flex: 0 0 auto; margin-right: var(--s-2); vertical-align: middle; }
.source-tag { height: 18px; padding: 0 var(--s-2); font: 600 var(--t-micro)/1 var(--font-ui); }
</style>
